<template>
    <section>
        <h2 class="nadia-subtitle text-ink mb-2">{{ t("assessments.results.themes.title") }}</h2>
        <p class="body-small text-ink-muted mb-2.5">{{ t("assessments.results.themes.subtitle") }}</p>
        <BaseCard padding="lg">
            <ul class="flex flex-col gap-4 body text-ink">
                <li v-for="theme in themes" :key="theme.title">
                    <div class="body-small-bold">{{ theme.title }}</div>
                    <p v-if="theme.summary" class="body-small text-ink-muted mt-1 leading-relaxed">{{ theme.summary }}</p>
                </li>
            </ul>
        </BaseCard>
    </section>
</template>

<script setup lang="ts">
import BaseCard from "~vue/components/BaseCard.vue";
import { useI18n } from "vue-i18n";

import type { Theme } from "./types";

interface Props {
    themes: Theme[];
}

defineProps<Props>();

const { t } = useI18n();
</script>
